import http from '../api/http';
import { env } from '../env';
import fetchInstance from './fetchConfig';
// import md5 from 'js-md5'
//import { JSEncrypt } from 'jsencrypt'

export default {
    dot({params, callback}){ // 发送第三方的code
        http.get(`/v1/home/checkActualIncome?monDateTime=${params.monDateTime}&sunDateTime=${params.sunDateTime}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    sendXero({params, callback}){ // 发送第三方的code
        http.post(`/v1/xero/bind?code=${params.code}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    sendDeputy({params, callback}){ // 发送第三方的code
        http.post(`/v1/deputy/bind?code=${params.code}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    /*upload({params, callback}){ // 上传文件
        http.post(`/v1/venue/home/cvsUpload`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },*/
    upload({params, type, callback}){ // 上传文件
        http.post(`/v1/venue/cvsUpload?uploadType=${type}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    save({params, callback}){ // 保存首次进入场馆的profit Target
        http.post(`/v1/home/saveProfitTarget`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    progress({callback}){ // 步骤状态
        http.get(`/v1/home/stepStatus`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getdatum({params, callback, cancelToken}){ // 数据
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = null
        }
        http.post(`/v1/home/dashBoard`,params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    /**************************************************************************************************************************************************************************/
    labourApi({params, callback, cancelToken}){ // 数据
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = -999
        }
        http.post(`/v1/home-dashboard/dashBoard-Labour-Week-Trend`,params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    /*getDashBoardThirdParty({params, callback}){
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = null
        }
        http.post(`/v1/home-dashboard/dashBoard-third-party-data`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },*/
    getSycLastTime({callback}){
        http.post(`/v1/home-dashboard/dashBoard-get-syc-lastTime`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    syncLatestApi({callback}){
        http.post(`/v1/home-dashboard/dashBoard-syc-OrdersRevenueDailyToday`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    /*revenueWeekTrendApi({params, callback}){
        let data = params.data
        if (data.dashBoardId === 'THIS WEEK' || data.dashBoardId === 'LAST WEEK' || data.dashBoardId === 'NEXT WEEK' || (typeof(data.dashBoardId) === 'string' && data.dashBoardId.indexOf(' - ') !== -1)) {
            data.dashBoardId = null
        }
        http.post(`/v1/home-dashboard/dashBoard-Revenue-Week-Trend/${params.type}`, data).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },*/
    getDashBoardTargetActual({params, callback}){
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = null
        }
        http.post(`/v1/home-dashboard/dashBoard-target-actual`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    // 需要加上cancelToken
    dailyTrendApi({params, callback, cancelToken}){
        let data = params.data
        if (data.dashBoardId === 'THIS WEEK' || data.dashBoardId === 'LAST WEEK' || data.dashBoardId === 'NEXT WEEK' || (typeof(data.dashBoardId) === 'string' && data.dashBoardId.indexOf(' - ') !== -1)) {
            data.dashBoardId = -999
        }


        http.post(`/v1/home-dashboard/dashBoard-Daily-Trend/${params.type}/${params.weekDayIndex}`, data, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    /**************************************************************************************************************************************************************************/
    getActualIncome({params, callback}){ // 查询本周实际收入
        http.post(`/v1/home/actualIncome`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    updateActualIncome({params, fourWeeksAvg, callback}){ // 更新实际收入
        let final_params = {
            list: params,
            // fourWeeksAvg: fourWeeksAvg
        }
        http.put(`/v1/home/enterActualIncome`, final_params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    updateFromVenueActualIncome({params, callback}){ // 更新实际收入
        http.put(`/v1/home/enterActualIncomeOfRevenueHistory`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    tip({callback}){ // 获取提示语相关信息
        http.get(`/v1/home/deputy/prompt`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    neglect({params, callback}){ // 选择忽略工作表中发现的新名字
        http.put(`/v1/home/deputy/neglect/newName`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    neglect2({params, callback}){
        http.put(`/v1/home/deputy/ignore/noContract`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    neglectstaff({params, callback}){ // 选择忽略工作表中不存在的全职人员名字
        http.put(`/v1/home/deputy/neglect/staff`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    beOnLeave({params, callback}){ // 设置员工为休假中
        http.put(`/v1/home/deputy/beOnLeave`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    toInactive({params, callback}){ // 设置员工为不活跃的并设置剩余假日
        http.put(`/v1/home/deputy/toInactive`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    queryTemporary({callback, type}){
        http.post(`/v1/home/queryTemporary`).then(res => {
            callback(res, type)
        }).catch(err => {
            callback(err)
        })
    },
    queryTemporaryLastWeek({callback, type}){
        http.post(`/v1/home/queryTemporary-lastWeek`).then(res => {
            callback(res, type)
        }).catch(err => {
            callback(err)
        })
    },
    disXero({params, callback}){ // put请求无参，解绑xero
        http.put(`/v1/xero/revocation`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    disDeputy({params, callback}){ // put请求无参，解绑Deputy
        http.put(`/v1/deputy/revocation`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    disTanda({params, callback}){
        http.put(`/v1/tanda/tanda-revocation`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    checkType({params, callback}){
        http.post(`/v1/venue/checkCvsFile`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    reloadLabour({params, cancelToken, callback}){
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = null
        }

        http.post(`/v1/home/reloadLabour`, params, cancelToken).then(res => {
            callback(res, params)
        }).catch(err => {
            callback(err, params)
        })
    },
    over({params, callback}){ // 有需要覆盖的数据时重新上传
        http.post(`/v1/venue/overwriteCvs`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    clear({callback}){
        http.put(`/v1/home/clickProfitLossTips`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    termsAndConditions({callback}){
        http.put(`/v1/home/termsAndConditions`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pinUpdate({params, callback}){
        //let encrypt = new JSEncrypt()
        //encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzle2EdTQK72M+HC2nCvUbhjdNWTQTZ0VHYNYqlj6CjLE1+93MN4I1SkwB+4CHJp7eDQ0dB7s5OeFtD7K0Xi7c1AleYMqxnVJRmQhryyIIZCaB5nywKuPKC0sDI/zab4OThq0nSOfeUQOkY9JmIomy20bgRmRNxlIWFTVPLg6+DQIDAQAB')
        //params = encrypt.encrypt(params)
        //console.log(params)
        http.put(`/v1/venue/update-pin?pin=${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pinAdd({params, callback}){
        http.put(`/v1/venue/add-pin?pin=${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    unsubscribed({callback}){
        http.put(`/doshii/unsubscribed`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    posList({callback}){ // 查询所有pos品牌列表
        http.get(`/v1/venue/posList`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    posUpdate({params, callback}){
        http.put(`/v1/venue/update-pos?posId=${params.posId}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    skipStep({params, callback}){
        http.put(`/v1/venue/skip-step?type=${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    clickBindDoshii({callback}){
        http.post(`/v1/home/click-bind-doshii`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    // 需要加上cancelToken
    dayProfitRevenueLabour({params, callback, cancelToken}){
        let venueId = window.sessionStorage.getItem("subVenueId")
        if (params.dashBoardIx1d === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = -999
        }

        let url = `/v1/home-dashboard/dashboard/day-profit-revenue-labour/${venueId}/${params.dashBoardId}/${params.weekname}/${params.monDateTime}/${params.sunDateTime}`

        http.get(url, {}, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    async profitRevenueLabourV2(date, type='weekly') {
        // Parameter requirements:
        // - For weekly type: date should be the week start date
        // - For daily type: date should be the specific date and type should be 'daily'
        // This ensures proper data retrieval based on the selected time period

        let venueId = window.sessionStorage.getItem("subVenueId")

        try {
            const res = await fetchInstance(`/dashboard/v2/venues/${venueId}/${type}/${date}/view`)

            if (res.status === 200) {
                return await res.json()
            }
        } catch (error) {
            return null;
        }
    },
    async getChartData(date, chartType='labour') {

        const type = chartType === 'labour' ? 'labour-chart' : 'revenue-chart'
        let venueId = window.sessionStorage.getItem("subVenueId")

        let url = `/dashboard/v2/venues/${venueId}/daily/${date}/${type}`

        try {
            const res = await fetchInstance(url)
            if (res.status === 200) {
                return await res.json()
            }
        } catch (error) {
            return null;
        }
    },

    async getDashboardDetailedWeeklyV2(weekStart) {
        let venueId = window.sessionStorage.getItem("subVenueId")
        let url = `/dashboard/v2/venues/${venueId}/weekly/${weekStart}/view/details`

        try {
            const res = await fetchInstance(url)
            if (res.status === 200) {
                return await res.json()
            }
        } catch (error) {
            return null;
        }
    },

    weekProfitRevenueLabour({params, callback, cancelToken}){
        let venueId = window.sessionStorage.getItem("subVenueId")
        if (params.dashBoardId === 'THIS WEEK' || params.dashBoardId === 'LAST WEEK' || params.dashBoardId === 'NEXT WEEK' || (typeof(params.dashBoardId) === 'string' && params.dashBoardId.indexOf(' - ') !== -1)) {
            params.dashBoardId = -999
        }

        var platform = params.extensionParams ? params.extensionParams.platform : '',
        today = params.extensionParams ? params.extensionParams.today : ''
        let url = ''

        if (platform == 'oseries' || platform == 'kseries') {
            url = `/v1/home-dashboard/dashboard/week-profit-revenue-labour/${venueId}/${params.dashBoardId}/${params.monDateTime}/${params.sunDateTime}?platform=${platform}&today=${today}`

        } else if (platform == 'doshii' || platform == 'handl' || platform == 'redcat') {

            url = `/v1/home-dashboard/dashboard/week-profit-revenue-labour/${venueId}/${params.dashBoardId}/${params.monDateTime}/${params.sunDateTime}?today=${today}`
        }

        else {
            url = `/v1/home-dashboard/dashboard/week-profit-revenue-labour/${venueId}/${params.dashBoardId}/${params.monDateTime}/${params.sunDateTime}`

        }

        http.get(url, {}, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },


    // ===================================
    async saveEodReportNew(data) {
        let url = `/v1/venue/report/saveeodreport`
        return await http.post(url, data)
    },

    async getEodDataNew(date, type='lunch') {
        let url = `/v1/venue/report/getEodReport?formatted_date=${date}&type=${type}`

        return await http.get(url)
    },


    async saveEodReport(data) {
        let url = `/v1/venue/subvenue/report/saveeod`
        return await http.post(url, data)
    },

    async saveEodSetting(data) {
        let url = `/v1/venue/subvenue/eod/settings`
        return await http.post(url, data)
    },

    async getEodSetting() {
        let url = `/v1/venue/subvenue/eod/settings`
        return await http.get(url)
    },

    async getPeriodicData() {
        let url = `/v1/venue/subvenue/periodicreports/currentdate`
        return await http.get(url)
    },

    async getPeriodicDataByDates(date) {
        let url = `/v1/venue/subvenue/periodicreports/bydate?formatted_date=${date}`
        return await http.get(url)
    },

    async getEodData(date, type='lunch') {
        let url = `/v1/venue/subvenue/periodicreports/bydatenew2?formatted_date=${date}&type=${type}`

        return await http.get(url)
    },

    async getActualRevenueLabour({params, cancelToken}){
        let data = params.data
        if (data.dashBoardId === 'THIS WEEK' || data.dashBoardId === 'LAST WEEK' || data.dashBoardId === 'NEXT WEEK' || (typeof(data.dashBoardId) === 'string' && data.dashBoardId.indexOf(' - ') !== -1)) {
            data.dashBoardId = -999
        }
        let url = `/v1/home-dashboard/dashBoard-Daily-Trend/${params.type}/${params.weekDayIndex}`
        return await http.post(url, data, cancelToken)
    },
    // OSERIES REGISTERS API
    async getAllRegister ({venueId}) {

        let url = `/v1/oseries/api/${venueId}/register`

        return await http.get(url)
    },
    async saveVenueRegister ({venueId, data}) {
        let url = `/v1/oseries/${venueId}/register`

        return await http.put(url, data)
    },
    async getVenueRegisters ({venueId}) {
        let url = `/v1/oseries/${venueId}/register`

        return await http.get(url)
    },
    // OSERIES ALL PRODUCTS
    async getAllProducts ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/api/${venueId}/product`

        return await http.get(url)
    },

    async getAllTevalisProducts (siteId) {
        let url = `/v1/tevalis/category?siteId=${siteId}`

        return await http.get(url)
    },
    // OSERIES FOOD
    async saveVenueFood ({venueId, data}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/food`

        return await http.put(url, data)
    },

    async getVenueFood ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/food`

        return await http.get(url)
    },
    // OSERIES BEVERAGE
    async saveVenueBeverage ({venueId, data}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/beverage`

        return await http.put(url, data)
    },
    async getVenueBeverage ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/beverage`

        return await http.get(url)
    },
    // OSERIES REVENUE GROUP
    async getVenueRevenueGroup ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/revenueGroup`

        return await http.get(url)
    },

    async saveVenueRevenueGroup ({venueId, data}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/revenueGroup?revenueGroupId=${data}`

        return await http.put(url)
    },


    async getVenueCategoriesNew (type='options', revenueType='swiftPos') {
        let url = `/v1/${revenueType}/categories/${type}`

        return await http.get(url)
    },

    async saveVenueCategoriesNew (data, type='food', revenueType='swiftPos') {
        let url = `/v1/${revenueType}/categories/${type}`

        return await http.put(url, data)
    },

    async getVenueRevenueGroupNew (revenueType='swiftPos') {
        let url = `/v1/${revenueType}/revenue-group`

        return await http.get(url)
    },

    async saveVenueRevenueGroupNew (data, revenueType='swiftPos') {
        let url = `/v1/${revenueType}/revenue-group`

        return await http.put(url, data)
    },

    async getVenuePosRevenueGroup (revenueType='oolio') {
        let url = `/revenue/${revenueType}/v1/revenue-group`

        return await http.get(url)
    },

    async saveVenuePosRevenueGroup (data, revenueType='oolio') {
        let url = `/revenue/${revenueType}/v1/revenue-group`

        return await http.post(url, data)
    },

    async getVenuePosCategories (type='options', revenueType='oolio') {
        let url = `/revenue/${revenueType}/v1/categories/${type}`

        return await http.get(url)
    },

    async saveVenuePosCategories (data, type='food', revenueType='oolio') {
        let url = `/revenue/${revenueType}/v1/categories/${type}`

        return await http.post(url, data)
    },

    async getVenueTerminalOptionsNew (revenueType='swiftPos') {
        let url = `/v1/${revenueType}/configuration`

        return await http.get(url)
    },

    async getVenueTerminalsNew (revenueType='swiftPos') {
        let url = `/v1/${revenueType}/terminals`

        return await http.get(url)
    },

    async saveVenueTerminalsNew (data, revenueType='swiftPos') {
        let url = `/v1/${revenueType}/terminals`

        return await http.put(url, data)
    },

    async getVenueDeviceOptionsNew (revenueType='swiftPos') {
        let url = `/v1/${revenueType}/devices/options`
        return await http.get(url)
    },

    async getVenueDevicesNew (revenueType='swiftPos') {
        let url = `/v1/${revenueType}/devices`
        return await http.get(url)
    },

    async saveVenueDevicesNew (data, revenueType='swiftPos') {
        let url = `/v1/${revenueType}/devices`
        return await http.put(url, data)
    },


    // SQUARE REVENUE
    async getSquareCategories (type='options') {
        let url = `/v1/square/categories/${type}`

        return await http.get(url)
    },

    async saveSquareCategories (data, type='food') {
        let url = `/v1/square/categories/${type}`

        return await http.put(url, data)
    },

    async getSquareRevenueGroup () {
        let url = `/v1/square/revenue-group`

        return await http.get(url)
    },

    async saveSquareRevenueGroup (data) {
        let url = `/v1/square/revenue-group`

        return await http.put(url, data)
    },

    async getSquareDeviceOptions () {
        let url = `/v1/square/devices/options`
        return await http.get(url)
    },

    async getSquareDevices () {
        let url = `/v1/square/devices`
        return await http.get(url)
    },

    async saveSquareDevices (data) {
        let url = `/v1/square/devices`
        return await http.put(url, data)
    },

    //end

    async saveVenueTerminal ({venueId, data}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/terminals`

        return await http.put(url, data)
    },

    async getTerminalList ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/api/${venueId}/terminals`
        return await http.get(url)
    },

    async getVenueTerminalList ({venueId}, revenueType='oseries') {
        let url = `/v1/${revenueType}/${venueId}/terminals`

        return await http.get(url)
    },

    async runEodWeeklyReport () {
        let url = `/v1/venue/report/runEodWeeklyReport`

        return await http.post(url)
    },

    async refreshLabourData (weekType) {
      var venueId = sessionStorage.getItem('subVenueId')
      let url = `/secure/v1/test/getRoster/${venueId}/${weekType}`
      return await http.get(url)
    },

    async runCashupEndofWeek() {
        let url = `/v1/venue/cashup/record/sendEndOfWeek`

        return await http.post(url)
    },
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js